var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustIcon20(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.662 14.91l-.743-.879c0-.022-1.014-1.216-1.735-1.937-.72-.72-1.711-1.464-1.734-1.464l.811-1.08c.045.022 1.081.81 1.892 1.598.36.36.766.811 1.104 1.194.405-.878 1.036-2.14 1.779-3.22 1.239-1.758 2.657-3.131 2.725-3.176l.946.968c-.023.023-1.396 1.351-2.568 2.996-1.148 1.621-2.05 3.918-2.072 3.941l-.405 1.058z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.329
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.045 0C7.793 2.432 2.5 2.477 2.5 2.477v10.45C2.5 17.186 10.045 20 10.045 20s7.545-2.815 7.545-7.072V2.478S12.297 2.431 10.045 0zm6.419 12.477c0 3.627-6.396 5.991-6.396 5.991s-6.42-2.364-6.42-5.99V3.603s4.505-.023 6.397-2.095c1.915 2.072 6.419 2.095 6.419 2.095v8.873z",
    fill: "#000"
  })));
}
export default SvgTrustIcon20;